import React, { Fragment, useState } from 'react'
import { showAlertFailure } from 'client/methods'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import AuthFormFooter from 'components/auth/AuthFormFooter'
import AuthTitle from 'components/internal/AuthTitle'
import Button from 'components/buttons/Button'
import Card from 'components/cards/Card'
import Column from 'components/base/Column'
import RadioInput from 'components/inputs/RadioInput'
import Row from 'components/base/Row'
import useMutation from 'hooks/useMutation'
import { SEND_MFA_CODE_MUTATION } from 'models/MFA'

function MfaSetupPage() {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()

  const { account, session } = location.state || {}
  const phoneNumber = account?.maskedPhone

  const [method, setMethod] = useState('totp')

  const [sendMfaCode, { loading: isSending }] = useMutation(
    SEND_MFA_CODE_MUTATION,
    {
      onCompleted: res => {
        const masked = res?.sendMfaCode?.targetMasked

        history.push({
          pathname: '/mfa/verify',
          state: {
            account,
            session,
            channel: method,
            mfaContext: { backup_target_masked: masked }
          }
        })
      },
      onError: () => {
        showAlertFailure({ message: t('mfa.errors.sendCode') })
      }
    }
  )

  if (!account || !session) {
    history.replace('/login')
    return null
  }

  const handleContinue = () => {
    if (method === 'totp') {
      history.push({
        pathname: '/mfa/authenticator',
        state: { account, session }
      })
      return
    }

    if (method === 'sms') {
      if (phoneNumber) {
        sendMfaCode({
          channel: 'sms',
          target: null,
          accessToken: session?.accessToken
        })
        return
      }

      history.push({
        pathname: '/mfa/backup/sms',
        state: { account, session, isEnrollmentBackup: false }
      })
      return
    }

    if (method === 'email') {
      sendMfaCode({
        channel: 'email',
        target: account.email,
        accessToken: session?.accessToken
      })
    }
  }

  const authList = [
    {
      value: 'totp',
      label: t('mfa.setup.authenticatorOption'),
      subLabel: t('mfa.setup.authenticatorOptionSub')
    },
    // {
    //   value: 'sms',
    //   label: t('mfa.setup.smsOption'),
    //   subLabel: t('mfa.setup.smsOptionSub')
    // },
    {
      value: 'email',
      label: t('mfa.setup.emailOption'),
      subLabel: t('mfa.setup.emailOptionSub')
    }
  ]

  return (
    <Fragment>
      <AuthTitle
        title={t('mfa.setup.title')}
        subtitle={`${t('mfa.setup.subtitle1')} 
        ${t('mfa.setup.subtitle2')}`}
        subtitlePosition="below"
      />

      <Row>
        <Column span={3} hiddenMd hiddenXs />
        <Column span={6} spanMd={12}>
          <Card variant="secondary">
            {authList.map(({ value, label, subLabel }) => (
              <RadioInput
                key={value}
                name="method"
                value={value}
                label={label}
                subLabel={subLabel}
                checked={method === value}
                onChange={() => setMethod(value)}
                textColor="light"
                textSize="small"
                textWeight="medium"
                subLabelColor="light"
                subLabelSize="xSmall"
                subLabelWeight="regular"
              />
            ))}

            <AuthFormFooter>
              <Button
                label={t('mfa.buttons.continue')}
                onClick={handleContinue}
                disabled={isSending}
              />
            </AuthFormFooter>
          </Card>
        </Column>
      </Row>
    </Fragment>
  )
}

export default MfaSetupPage
